export const CONTRACT_SEPOLIA = "0x105088644A2CFebDAEeE95fb3F4f29abF75f700E";
export const CONTRACT_ARB = "0xB1BB87FF47988C3cA10822d13E0cE7A381C40974";
export const CONTRACT_BASE = "0x3219b1E9ec313ff51a95a3CAC987c293CaeAdD71";
export const CONTRACT_POLYGON = "0x8Ff56a5527ed1faa9cAF25aD3EF7cDDe7Aa2d794";
export const CONTRACT_SCROLL = "0xB1BB87FF47988C3cA10822d13E0cE7A381C40974";
export const CONTRACT_ZKEVM = "0x82f9C4aE967e27E333F9EDC7Ef45224b62e9ea05";
export const ABI = [
  { inputs: [], name: "LENGTHS_MISMATCH", type: "error" },
  { inputs: [], name: "NOT_OWNER", type: "error" },
  { inputs: [], name: "ONLY_INITIATOR", type: "error" },
  { inputs: [], name: "PAY_FEE", type: "error" },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  { inputs: [], name: "TRADE_CLOSED", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tradeId",
        type: "uint256",
      },
    ],
    name: "TradeAccepted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tradeId",
        type: "uint256",
      },
    ],
    name: "TradeCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tradeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address[]",
        name: "nfts",
        type: "address[]",
      },
      {
        indexed: true,
        internalType: "address[]",
        name: "requestNfts",
        type: "address[]",
      },
    ],
    name: "TradeOpened",
    type: "event",
  },
  {
    inputs: [
      { internalType: "uint256", name: "tradeId", type: "uint256" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
    ],
    name: "acceptTrade",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tradeId", type: "uint256" }],
    name: "cancelTrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tradeId", type: "uint256" }],
    name: "getOffers",
    outputs: [
      { internalType: "address[]", name: "", type: "address[]" },
      { internalType: "uint256[]", name: "", type: "uint256[]" },
      { internalType: "address[]", name: "", type: "address[]" },
      { internalType: "bool", name: "", type: "bool" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" },
    ],
    name: "onERC721Received",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "offerNfts", type: "address[]" },
      { internalType: "uint256[]", name: "offerNftIds", type: "uint256[]" },
      { internalType: "address[]", name: "requestNfts", type: "address[]" },
    ],
    name: "openTrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "trades",
    outputs: [
      { internalType: "address", name: "initiator", type: "address" },
      { internalType: "bool", name: "isOpen", type: "bool" },
    ],
    stateMutability: "view",
    type: "function",
  },
];
